<template>
  <div class="set-display">
        <div class="tw-mt-10 reel-images">
          <div class="auto-slider-container-home">
            <div class="auto-slider-row-home">
              <img src="../assets/images/image-reels/row-1/01.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/02.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/03.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/04.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/05.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/06.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/07.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/08.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/09.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/10.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/11.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/12.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/36.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/01.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/02.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/03.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/04.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/05.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/06.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/07.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/08.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/09.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/10.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/11.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/12.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/36.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/01.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/02.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/03.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/04.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/05.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/06.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/07.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/08.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/09.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/10.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/11.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/12.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-1/36.webp" alt="Contenu">
            </div>
          </div>
          <div class="auto-slider-container-home">
            <div class="auto-slider-row-home reverse">
              <img src="../assets/images/image-reels/row-2/13.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/14.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/15.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/16.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/17.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/18.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/19.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/20.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/21.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/22.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/23.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/35.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/13.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/14.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/15.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/16.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/17.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/18.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/19.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/20.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/21.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/22.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/23.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/35.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/13.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/14.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/15.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/16.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/17.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/18.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/19.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/20.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/21.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/22.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/23.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-2/35.webp" alt="Contenu">
            </div>
          </div>
          <div class="auto-slider-container-home">
            <div class="auto-slider-row-home">
              <img src="../assets/images/image-reels/row-3/24.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/25.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/26.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/27.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/28.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/29.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/30.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/31.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/32.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/33.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/34.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/37.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/24.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/25.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/26.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/27.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/28.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/29.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/30.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/31.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/32.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/33.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/34.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/37.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/24.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/25.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/26.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/27.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/28.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/29.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/30.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/31.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/32.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/33.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/34.webp" alt="Contenu">
              <img src="../assets/images/image-reels/row-3/37.webp" alt="Contenu">
            </div>
          </div>
        </div>
        <img src="../assets/images/bottom-right-tri.png" alt="Contenu" class="tri-image-display">
  </div>
  </template>
  
  <script>
  export default {
    name: 'App',
  }
  </script>
  
  <style scoped>
  .tri-image-display {
    width: 100vw;
    min-width: 100vw;
    @media (orientation: portrait) {
      display: none;
    }
  }
  .set-display {
    display: grid;
  }
  .reel-images {
    width: 110%;
    min-width: 100vw; /* Ensures it takes full viewport width */
    transform: rotate(-3deg) translateY(50px);
    position: relative;
    display: block;
    margin-left: -5%;
    margin-right: -5%;
    margin-bottom: -2%;
    overflow: hidden;
    z-index: 1; 
    background-color: #020076;

    @media (orientation: portrait) {
      transform: rotate(0deg) translateY(0px);
      padding-bottom: 30px;
    }
  }
  .reel-images::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3%;
    background-color: white;
    z-index: 0; /* Behind the main content */
}

  .auto-slider-container-home {
    height: 120px;
    margin: 6px 0;
    overflow: hidden;
    position: relative;
  }
  .auto-slider-row-home {
    animation: row-anim 80s linear infinite;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    white-space: nowrap;
    will-change: transform;

    img {
      border-radius: 10px;
    }
  }

  .auto-slider-row-home.reverse {
    animation: row-anim-reverse 80s linear infinite;
    left: auto;
    right: 0;
  }

  .auto-slider-row-home img {
    display: inline-block;
    margin: 0 3px;
    height: 120px;
    max-width: none;
  }
  .auto-slider-row {
    animation: row-anim 80s linear infinite;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    white-space: nowrap;
  }

  .auto-slider-row.reverse {
    animation: row-anim-reverse 80s linear infinite;
    left: auto;
    right: 0;
  }
  @keyframes row-anim {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(-50%, 0, 0);
    }
  }

  @keyframes row-anim-reverse {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(50%, 0, 0);
    }
  }

  </style>
  <style>
  .title-shadow {
    text-shadow: 2px 0 0 rgba(109, 76, 65, 0.5);
  }

  .auto-slider-container {
    height: 156px;
    margin: 10px 0;
    overflow: hidden;
    position: relative;
  }

  .auto-slider-row {
    animation: row-anim 80s linear infinite;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    white-space: nowrap;
  }

  .auto-slider-row.reverse {
    animation: row-anim-reverse 80s linear infinite;
    left: auto;
    right: 0;
  }

  .auto-slider-row img {
    display: inline-block;
    margin: 0 6px;
    max-width: none;
  }

  @keyframes row-anim {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(-50%, 0, 0);
    }
  }

  @keyframes row-anim-reverse {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(50%, 0, 0);
    }
  }

</style>